import { format, distanceInWordsStrict } from "date-fns";

export function longDateFormat(date) {
  return format(date, "dddd Do MMM, YYYY");
}

export function dateWithTimeFormat(date) {
  return format(date, "D MMM, YYYY HH:mm");
}

export function simpleDateFormat(date) {
  return format(date, "YYYY-MM-DD")
}

export function relativeDistanceUTC(date) {
  return distanceInWordsStrict(toUTC(new Date()), toUTC(date), {addSuffix: true});
}

export function relativeDistanceUTCFromString(dateStr) {
  return distanceInWordsStrict(toUTC(new Date()), fromUTCString(dateStr), {addSuffix: true});
}

function toUTC(date) {
  var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  return new Date(now_utc);
}

export function fromUTCString(dateStr) {
  var m = String(dateStr).match(/([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})/);
  if (m) {
    return new Date(Date.UTC(m[1], m[2]-1, m[3], m[4], m[5], m[6]));
  }
  return "invalid date";
}